import { Collections } from '@/domain/services/Rt/DataSource';
import { useCollaborativeSubmittable } from '@/modules/entry-form/Collaboration/services/CollaborativeSubmittable';
import { DocumentService, documentServiceFactory, nullDocumentService } from '@/domain/services/Collaboration/Document';

type FlagsSubmittableData = {
	isIneligible?: boolean;
	updatedAt: string;
};

// Override the type of "set" by using Omit to define our custom FlagsSubmittableData type
type FlagsSubmittable = {
	service: Omit<ReturnType<typeof nullDocumentService<FlagsSubmittableData>> | DocumentService, 'set'> & {
		set: (data: FlagsSubmittableData, forceSet: boolean) => void;
	};
};

const emptyFlagsSubmittable = () => ({
	...nullDocumentService(),
});

const flagsSubmittable = (): FlagsSubmittable => {
	const { submittableSlug, formSlug, supportsRealTimeUpdates } = useCollaborativeSubmittable();

	if (!supportsRealTimeUpdates) {
		return {
			service: emptyFlagsSubmittable(),
		};
	}

	const document = documentServiceFactory(submittableSlug, formSlug)(Collections.FlagsSubmittable);
	return {
		service: {
			...document,
			set: (data: FlagsSubmittableData, forceSet = false) => document.set(data, forceSet),
		},
	};
};

export { flagsSubmittable };
export type { FlagsSubmittableData, FlagsSubmittable };
